import { render, staticRenderFns } from "./ChallengeResetModal.vue?vue&type=template&id=16ad1752"
import script from "./ChallengeResetModal.vue?vue&type=script&lang=js"
export * from "./ChallengeResetModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports